import { Link } from 'react-router-dom';
import { i18n as i } from '../../../i18n';
import Exception from '../../../components/Exception';

function NoServer(props: any) {
  return (
    <Exception type="500" desc={i('抱歉，服务器出错了')} style={{ minHeight: 500, height: '80%' }} linkElement={Link} {...props} />
  );
} 

export default NoServer;
